import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CompanyHero from './components/CompanyHero';
import CompanyInfo from './components/CompanyInfo';
import CompanyHistory from './components/CompanyHistory';

const CompanyPage = () => {
  usePageMeta({
    title: '会社情報 | 株式会社MSK',
    ogTitle: '会社情報 | 株式会社MSK',
    description: '株式会社MSKの企業情報をご紹介いたします。企業概要・沿革・経営理念など、MSKについての詳細をご覧いただけます。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <CompanyHero />
        <CompanyInfo />
        <CompanyHistory />
      </main>
      <Footer />
    </div>
  );
};

export default CompanyPage;